<template>
<div class="chapter">
<div class="inner_page">
<p class="ctp"><span><a href="#/Book1/content#tree36" id="terr36">Part One</a><br/><a href="#/Book1/content#tree36">Madame Rosa’s</a></span></p>
<p class="ct1"><span>Monday Afternoon to Wednesday Afternoon</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_One.vue?c4767826